import textServices from 'services/text-services'
import { useSession } from 'contexts/session-context'
import Button from 'components/button'
import * as htmlToImage from 'html-to-image';
import { ContainerCard, IdCard, ImgCard } from './styles'

const Identification = () => {

  const [{ user }] = useSession()

  const handleDownload = () => {
    const element = document.getElementById('my-id-card');
    htmlToImage.toPng(element)
      .then((dataUrl) => {
        const link = document.createElement('a');
        link.download = 'mi-id.png';
        link.href = dataUrl;
        link.click();
      });
  }

  return (
    <div className="font-bold text-2xl py-7 flex-1 flex flex-col break-all justify-evenly">
      <div className='flex flex-col items-center py-5'>
        <ContainerCard className='w-72 flex flex-col items-center gap-2 relative ' id='my-id-card'>
          {/* <SwitchCard className='mx-auto w-9 h-2 rounded-full' /> */}
          <ImgCard alt='Card Icon' src={`${AZURE_BASE_URL}/card-id.png`} className='rounded-xl shadow-lg drop-shadow-2xl' />
          {/* <TitleCard>{textServices.findByText('profile/identification/title', 'MI ID')}</TitleCard> */}
          <IdCard className='absolute ' style={{ bottom: '51px' }}>#{user?.id}</IdCard>
        </ContainerCard>
      </div>
      <div className='px-10'>
        <Button
          className={`mixx-button w ${!window.navigator.share ? 'col-span-2' : ''}`}
          onClick={handleDownload}
        >
          {textServices.findByText('profile/identification/button', 'DESCARGAR MI ID')}
        </Button>
      </div>
    </div>
  )
}

export default Identification